import React, { useState } from "react";
import Loading from "../../../Common/Loading";

function AdvertisingBoxes({ landingLoading, background = false }) {
  const elements = useState([
    {
      top: "رزرو آسان در",
      bottom: "هرساعت از شبانه روز",
      src: window.origin + "/WebSide/assets/images/1.png",
    },
    {
      top: "ارائه تخفیف های",
      bottom: "دوره ای",
      src: window.origin + "/WebSide/assets/images/2.png",
    },
    {
      top: " نزدیک ترین",
      bottom: "مجموعه های ورزشی",
      src: window.origin + "/WebSide/assets/images/3.png",
    },
    {
      top: "مقایسه مجموعه های",
      bottom: "ورزشی",
      src: window.origin + "/WebSide/assets/images/4.png",
    },
  ])[0];
  if (landingLoading) {
    return (
      <div className="container">
        <div className="row advertisingBoxes">
          <Loading count={4} height={100} />
        </div>
      </div>
    );
  }
  return (
    <section
      className={`${background ? "background-gray" : ""}   `}
      style={{ paddingBottom: "14px" }}
    >
      <div className="container">
        <div className="row advertisingBoxes">
          {elements.map((element, key) => {
            return (
              <div className="col-sm-6 col-lg-3 mt-2" key={key}>
                <div className="card-shadow-web d-flex ">
                  <div className="d-flex align-items-center justify-content-center">
                    <img src={element.src} alt="nikotan | نیکوتن" />
                  </div>
                  <div className="d-flex flex-column w-100 justify-content-center">
                    <p
                      className="text-center"
                      style={{ color: "#616161", fontWeight: "400" }}
                    >
                      {element.top}
                    </p>
                    <p
                      className="text-center"
                      style={{ color: "#616161", fontWeight: "400" }}
                    >
                      {element.bottom}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default AdvertisingBoxes;
